import jQuery from 'jquery';
import {SavedListingRepository} from "./saved-listings/SavedListingRepository.js";
import {InfiniteScroll, InfiniteScrollOptions, InfiniteScrollPanel} from "./infiniteScroll.js";
import { ZIDX } from "./standaloneLibrary.js";
import {ListingThumbnailLayout1} from "./layout-options/ListingThumbnailLayout1.js";
import {ListingThumbnailLayout2} from "./layout-options/ListingThumbnailLayout2.js";
import {ListingThumbnailLayout3} from "./layout-options/ListingThumbnailLayout3.js";
import {ZIDXListingSummary, LISTING_LAYOUT_LIST, LISTING_LAYOUT_DETAIL, LISTING_LAYOUT_MAP, searchIsEmbedded} from "./ListingModels.js";
import type { ZIDXBase } from "./base.js";

let $=jQuery.noConflict();

export function numberFormat(value: number): string {
    let formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    return formatter.format(value);
}

export function htmlEditFormat(value: any): any {
    if (typeof value == "string") {
        return value.replace("\\", "\\\\").replace("\"", "&quot;").replace("<", "&lt;").replace(">", "&gt;");
    } else {
        return value;
    }
}

export function timestampToDateFormat(UNIX_timestamp: number) {
    let a = new Date(UNIX_timestamp * 1000);
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let year = a.getFullYear();
    let month = months[a.getMonth()];
    let date = a.getDate();
    let hour = a.getHours();
    let min = a.getMinutes();
    let sec = a.getSeconds();
    return date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec;
}

export function urlEncode(value: string, escapeWith: string) {
    return value.replace(/[^A-Za-z0-9]/gi, escapeWith);
}

export function getListingURL(base: ZIDXBase, ss: ZIDXListingSummary) {
    var unit="";
    if(ss.address2!=""){
        unit="-unit-"+ss.address2;
    }
    return base.zidx.getPrefixURL("/listing/" + urlEncode(ss.address + unit + "-" + ss.city + "-" + ss.state + "-" + ss.postalCode + "-" + ss.indexId + "-" + ss.id, "-").replace(/--*/gi, "-")+"/");
}

export function getLayoutString(base: ZIDXBase, id: number):string {
    switch (id) {
        case LISTING_LAYOUT_LIST:
            return "zidxList";
        case LISTING_LAYOUT_DETAIL:
            return "zidxDetail";
        case LISTING_LAYOUT_MAP:
            return "zidxMap";
        default:
            if (base.zidx.options.debug) console.log("Invalid layout:" + id);
            return "zidxList";
            break;
    }
}

export function renderListingThumbnailList(base: ZIDXBase, ss: ZIDXListingSummary, panel: InfiniteScrollPanel): string {
    const isSaved = SavedListingRepository.getInstance(base.zidx).isSaved(ss.id);
    let arrHTML = [];
    arrHTML.push("<div title=\"View Listing\" class=\"zidxSearchResultListingImage");
    if (!panel.visible) {
        arrHTML.push(" zidxImageNotLoaded\" data-image=\"" + ss.photo + "\"");
    }
    if (panel.visible) {
        arrHTML.push("\" style=\"background-image:url('" + ss.photo + "');\"");
    }
    arrHTML.push("><div class=\"zidxSearchResultListingPrice\">");
    if (base.renderSaveButton) {
        arrHTML.push(`
                <div class=\"zidxSearchResultListingSaveButton\">
                    <i title=\"Save property\" data-id='${ss.indexId+":"+ss.id}' data-unique-id='${ss.uniqueId}' saved='${isSaved}' class=\"fa ${isSaved ? 'fa-heart' : 'fa-heart-o'} zidxSearchResultSave\" aria-hidden=\"true\"></i>
                </div>
        `);
    }
    if (ss.price != 0) {
        arrHTML.push("$" + numberFormat(ss.price));
    }
    arrHTML.push("</div></div>\n" +
        "            <div class=\"zidxSearchResultListingTextContainer\">\n" +
        "            <div title=\"View Listing\">\n");
    let specs = [];
    if (ss.bedrooms != 0) {
        specs.push(ss.bedrooms + " Beds &nbsp; ");
    }
    if (ss.bathrooms != 0) {
        specs.push(ss.bathrooms + " Baths &nbsp; ");
    }
    if (ss.halfBaths != 0) {
        specs.push(ss.halfBaths + " Half Baths &nbsp; ");
    }
    if (ss.sqft != 0) {
        specs.push(ss.sqft + " SQFT");
    }
    if (specs.length > 0) {
        arrHTML.push("<div class=\"zidxSearchResultListingSpecs\">" + specs.join("") + "</div>");
    }
    arrHTML.push(
        "                <div class=\"zidxSearchResultListingAddress\">\n" +
        "                " + ss.address + "&nbsp;<br>\n" +
        "            " + ss.city + ", " + ss.state + " " + ss.postalCode + "\n" +
        "            </div>\n" +
        "            <div class=\"zidxSearchResultListingType\">\n" +
        "                " + ss.type + "&nbsp;\n" +
        "            </div>\n" +
        "            <div class=\"zidxSearchResultListingStatus\">\n" +
        "                " + ss.listStatus + "&nbsp;\n" +
        "            </div>\n" +
        "            </div>\n" +
        "            </div>");
    return arrHTML.join("");
}

export function renderListingThumbnailDetail(base: ZIDXBase, ss: ZIDXListingSummary, panel: InfiniteScrollPanel): string {
    let arrHTML = [];
    const isSaved = SavedListingRepository.getInstance(base.zidx).isSaved(ss.id);

    arrHTML.push("<div title=\"View Listing\" class=\"zidxSearchDetailImage");
    if (!panel.visible) {
        arrHTML.push(" zidxImageNotLoaded\" data-image=\"" + ss.photo + "\"");
    }
    if (panel.visible) {
        arrHTML.push("\" style=\"background-image:url('" + ss.photo + "');\"");
    }
    arrHTML.push("><span>" + htmlEditFormat("Photo of " + ss.address) + "</span></div>\n");

    arrHTML.push("<div class=\"zidxSearchDetailPrice\">");
    if (ss.price != 0) {
        arrHTML.push("$" + numberFormat(ss.price));
    }
    arrHTML.push("</div><div class=\"zidxSearchDetailSQFT\">");
    if (ss.sqft != 0) {
        arrHTML.push(ss.sqft + " SQFT");
    }
    arrHTML.push("</div><div class=\"zidxSearchDetailBeds\">");
    if (ss.bedrooms != 0) {
        arrHTML.push(ss.bedrooms + " Beds");
    }
    arrHTML.push("</div><div class=\"zidxSearchDetailBaths\">");
    if (ss.bathrooms != 0) {
        arrHTML.push(ss.bathrooms + " Baths");
    }
    if (ss.halfBaths != 0) {
        arrHTML.push("<br>" + ss.halfBaths + " Half Baths &nbsp; ");
    }
    arrHTML.push("</div>\n" +
        "            <div class=\"zidxSearchDetailType\">\n" +
        "            " + ss.type + "\n" +
        "        </div>\n" +
        "        <div class=\"zidxSearchDetailStatus\">\n" +
        "            " + ss.listStatus + "\n" +
        "        </div>\n" +
        "        <div class=\"zidxSearchDetailAddress\">\n" +
        "            " + ss.address + "<br>\n" +
        "        " + ss.city + ", " + ss.state + " " + ss.postalCode + "\n" +
        "        </div>");

    if (base.renderSaveButton) {
        arrHTML.push(`
                <div class=\"zidxSearchDetailSaveButton\">
                    <i title=\"Save property\" data-id='${ss.indexId+":"+ss.id}' data-unique-id='${ss.uniqueId}' saved='${isSaved}' class=\"fa ${isSaved ? 'fa-heart' : 'fa-heart-o'} zidxSearchResultSave\" aria-hidden=\"true\"></i>
                </div>
        `);
    }
    return arrHTML.join("");
}

export function displayListings(base: ZIDXBase) {
    if (base.infiniteScroll != null) {
        base.infiniteScroll.options.count = base.listingData.totalListings;
        base.infiniteScroll.update();
        if(base.listingData.totalListings>base.infiniteScroll.loadedCount){
            $(".zidxLoadMoreButton", base.zidx.peakidxShadowRoot).show();
        }else {
            $(".zidxLoadMoreButton", base.zidx.peakidxShadowRoot).hide();
        }
    }
    let self=base;
    $(".zidxSearchResultsGridContainer", base.zidx.peakidxShadowRoot).trigger("wheel");
    if ($(".zidxSearchMapLink", base.zidx.peakidxShadowRoot).hasClass("zidxActive")) {
        base.loadMap(function () {
            self.zidx.zidxMap.displayMapMarkers();
        });
    }
}

export function listingPanelRenderCallback(base: ZIDXBase, panel: InfiniteScrollPanel) {
    base.currentOffset = Math.floor(panel.offset / 200) * 200;
    if (base.listingData.listings.length == 0) {
        return;
    } else if (base.currentOffset != 0 && typeof base.listingDataOffsetsLoaded[base.currentOffset] == "undefined") {
        if (typeof base.listingDataOffsetsLoading[base.currentOffset] != "undefined") {
            return;
        }
        $("#zidx_offset", base.zidx.peakidxShadowRoot).val(base.currentOffset);
        base.listingDataOffsetsLoading[base.currentOffset] = true;
        console.log("checkForSearchFormChanges 1");
        base.checkForSearchFormChanges(true, false);
        return;
    }
    let ss = base.listingData.listings[panel.offset];
    if(!ss){
        panel.element.style.display="none";
        return;
    }
    panel.element.style.display="block";
    const link = getListingURL(base, ss);
    panel.element.setAttribute('data-id', ss.indexId + ":" + ss.id);
    panel.element.setAttribute('data-unique-id', String(ss.uniqueId));
    panel.element.href=base.searchDomain + link;
    if (base.zidx.zidxBase.openInNewTab) {
        panel.element.target="_blank";
        panel.element.rel="noopener noreferrer";
    }
    $(panel.element).on('mouseover', base.onSearchResultMouseOver)
    $(panel.element).on('mouseout', base.onSearchResultMouseOut)
    let content;
    let thumbnailLayoutNum: string;
    if (base.lastPostObj.zidx_layout == LISTING_LAYOUT_DETAIL) {
        content = renderListingThumbnailDetail(base, ss, panel);
        thumbnailLayoutNum = "2";
    } else {
        switch (base.lastPostObj.zidx_layout) {
            case LISTING_LAYOUT_DETAIL:
                thumbnailLayoutNum = "2";
                content = new ListingThumbnailLayout2(base.zidx).render(ss, panel);
                break;
            case LISTING_LAYOUT_MAP:
                thumbnailLayoutNum = "3";
                content = new ListingThumbnailLayout3(base.zidx).render(ss, panel);
                break;
            default: // LISTING_LAYOUT_LIST
                thumbnailLayoutNum = "1";
                content = new ListingThumbnailLayout1(base.zidx).render(ss, panel);
                break;
        }
    }
    panel.render('<div class="zidxSearchResultListingBorderContainer zidxListingThumbnailLayout'+thumbnailLayoutNum+'">'+content+'</div>');
    panel.rendered = true;
}

export function setupListingSearchInfiniteScroll(base: ZIDXBase) {
    if($(".zidxListingScrollContainer", base.zidx.peakidxShadowRoot).length==0){
        return;
    }
    let containerScrollerElement = $(".zidxSearchResultsGridContainer", base.zidx.peakidxShadowRoot)[0] as HTMLDivElement;
    let containerElement = $(".zidxListingScrollContainer", base.zidx.peakidxShadowRoot)[0] as HTMLDivElement;
    let options = new InfiniteScrollOptions(containerScrollerElement, containerElement, base, "listingPanelHeightCallback", "listingPanelRenderCallback", searchIsEmbedded);
    options.debug = false;
    options.count = parseInt($(".zidxSearchMorePopupResultCount", base.zidx.peakidxShadowRoot)[0].innerHTML);
    if(isNaN(options.count)){
        options.count=10000;
    }
    options.panelClass = "zidxSearchResultListingContainer";
    base.infiniteScroll = new InfiniteScroll(options, base.zidx);
    let count=parseInt($(".zidxSearchResultsHeader .zidxSearchMorePopupResultCount", base.zidx.peakidxShadowRoot)[0].innerHTML);
    // console.log("setupListingSearchInfiniteScroll", count);
    base.infiniteScroll.setCount(count);
}
